import {createStore} from 'redux';
import appevaweb from './reducers/index';

export default createStore(appevaweb);